import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || "";

/**
 * useWaitlistStatus — polls the public /api/system/waitlist-status endpoint
 * so every signup entry point (PatientRegister, PatientOnboarding, fit-quiz
 * CTA landing) can decide whether to render the WaitlistGate instead of the
 * normal flow. Fails open (enabled=false) if the API is unreachable so a
 * network hiccup doesn't accidentally block real signups.
 */
export function useWaitlistStatus() {
  const [status, setStatus] = useState({ loading: true, enabled: false, message: "" });

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/api/system/waitlist-status`)
      .then(({ data }) => {
        if (cancelled) return;
        setStatus({
          loading: false,
          enabled: !!data.enabled,
          message: data.message || "",
        });
      })
      .catch(() => {
        if (cancelled) return;
        setStatus({ loading: false, enabled: false, message: "" });
      });
    return () => { cancelled = true; };
  }, []);

  return status;
}
